
<template>
  <div>
    <p class="decode-result">
      <a @click="redireccionar" :href="Items" v-text="Items"></a>
    </p>

   <!-- <input v-model="Items" v-on:input="redireccionar" type="text" disabled>-->

    <qrcode-stream
      :paused="paused"
      @detect="onDetect"
      @camera-on="onCameraOn"
      @camera-off="onCameraOff"
      @error="onError"
    >
      <div
        v-show="showScanConfirmation"
        class="scan-confirmation"
      >
        <img
          :src="'./assets/checkmark.svg'"
          alt="Checkmark"
          width="128"
        />
      </div>
    </qrcode-stream>
  </div>
</template>

<script>



import { QrcodeStream } from 'vue-qrcode-reader'



export default {
  name: 'HelloWorld',
  components: { QrcodeStream },

  data() {
    return {
      paused: false,
      result: '',
      showScanConfirmation: false
    }
  },

  methods: {
    onCameraOn() {
      this.showScanConfirmation = false
    },

    onCameraOff() {
      this.showScanConfirmation = true
    },

    onError: console.error,

    async onDetect(detectedCodes) {
      this.result = JSON.stringify(detectedCodes.map((code) => code.rawValue))

      this.paused = true
      await this.timeout(500)
      this.paused = false
    },

    timeout(ms) {
      return new Promise((resolve) => {
        window.setTimeout(resolve, ms)
      })
    },

    redireccionar(){

      if(this.Items != null ){

        window.location.replace(this.Items); 


      }



    }
    
  },
  computed: {
    Items() {
        if(this.result!=null){
          
          var rr = this.result.replace('"','').replace('"','').replace('[','').replace(']','');

          if(rr.includes('74.208.92.151'))
            rr = rr.replace('74.208.92.151','45.190.240.158');

        

          return rr;
        }  
          
        else 
            return null;
          },

     

      
},
}
</script>

<style scoped>
.scan-confirmation {
  position: absolute;
  width: 100%;
  height: 100%;

  background-color: rgba(255, 255, 255, 0.8);

  display: flex;
  flex-flow: row nowrap;
  justify-content: center;
}
</style>